import { Bell, MessageSquare, Sun } from "lucide-react";
import { useLocation } from "react-router-dom";

const BREADCRUMB_MAP = {
  "/dashboard": { parent: "Main Menu", label: "Dashboard" },
  "/products": { parent: "Main Menu", label: "Products" },
  "/shops": { parent: "Main Menu", label: "Shops" },
  "/orders": { parent: "Main Menu", label: "Orders" },
  "/shipments": { parent: "Main Menu", label: "Shipments" },
  "/delivery-requests": { parent: "Main Menu", label: "Delivery Requests" },
  "/categories": { parent: "Main Menu", label: "Categories" },
  "/customers": { parent: "Main Menu", label: "Customers" },
  "/analytics": { parent: "Main Menu", label: "Analytics" },
  "/discounts": { parent: "Main Menu", label: "Discounts" },
  "/payments": { parent: "Main Menu", label: "Payments" },
  "/team": { parent: "Main Menu", label: "Team" },
  "/logs": { parent: "Other", label: "Activity Logs" },
  "/shipping/countries": { parent: "Shipping", label: "Countries" },
  "/shipping/warehouses": { parent: "Shipping", label: "Warehouses" },
  "/shipping/companies": { parent: "Shipping", label: "Companies" },
  "/shipping/prices": { parent: "Shipping", label: "Prices" },
  "/shipping/categories": { parent: "Shipping", label: "Categories" },
  "/campaigns/all": { parent: "Campaign", label: "All Campaigns" },
  "/campaigns/segments": { parent: "Campaign", label: "Segments" },
  "/campaigns/categories": { parent: "Campaign", label: "Categories" },
  "/campaigns/products": { parent: "Campaign", label: "Products" },
  "/eleven/categories": { parent: "11.11", label: "Categories" },
  "/eleven/products": { parent: "11.11", label: "Products" },
  "/eleven/products/new": { parent: "11.11", label: "New Product" },
  "/eleven/carts": { parent: "11.11", label: "Carts" },
  "/eleven/payments": { parent: "11.11", label: "Payments" },
  "/eleven/orders": { parent: "11.11", label: "Orders" },
};

export default function Topbar() {
  const { pathname } = useLocation();

  const breadcrumb = BREADCRUMB_MAP[pathname] || {
    parent: "Main Menu",
    label: "Dashboard",
  };

  return (
    <header className="flex items-center justify-between rounded-tr-2xl border-b bg-white/60 px-6 py-4">
      <div className="flex items-center gap-2 text-sm text-slate-500">
        <span className="text-slate-400">{breadcrumb.parent}</span>
        <span className="text-slate-300">/</span>
        <span className="font-medium text-slate-700">{breadcrumb.label}</span>
      </div>

      <div className="flex items-center gap-3">
        <button className="rounded-xl bg-white p-2 ring-1 ring-slate-200 hover:bg-slate-50">
          <MessageSquare className="h-4 w-4 text-slate-600" />
        </button>
        <button className="rounded-xl bg-white p-2 ring-1 ring-slate-200 hover:bg-slate-50">
          <Bell className="h-4 w-4 text-slate-600" />
        </button>
        <button className="rounded-xl bg-white p-2 ring-1 ring-slate-200 hover:bg-slate-50">
          <Sun className="h-4 w-4 text-slate-600" />
        </button>
      </div>
    </header>
  );
}
